"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MultipleDates = function MultipleDates(props) {
  return _react2.default.createElement(
    "svg",
    (0, _extends3.default)({ width: 18, height: 18, viewBox: "0 0 18 18" }, props),
    _react2.default.createElement("path", {
      d: "M11 5H3v5H1V3h10v2zm3 3H6v6H4V6h10v2zm3 1v7H7V9h10z",
      fillRule: "evenodd"
    })
  );
};

exports.default = MultipleDates;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/icons/MultipleDates.js
// module id = 695
// module chunks = 0